/**
 * Schema of RelatorioGeracao
 * @author gabrielgil
 */
import { Schema } from 'simpli-web-sdk'
import { date, datetime } from 'simpli-web-sdk'
import RelatorioGeracao from '@/model/resource/RelatorioGeracao'
import RenderExclamation from '@/components/render/RenderExclamation.vue'
import { StatusRelatorioEnum } from '@/enums/StatusRelatorioEnum'

export default (model: RelatorioGeracao): Schema => ({
  idRelatorioGeracaoPk: {
    content: model.idRelatorioGeracaoPk,
    editable: false,
  },

  dataCriacao: {
    content: datetime(model.dataCriacao),
  },

  dataInicio: {
    content: date(model.dataInicio) || '-',
  },

  dataFim: {
    content: date(model.dataFim) || date(model.dataGeracaoRelatorio) || '-',
  },

  dataGeracaoRelatorio: {
    content: datetime(model.dataGeracaoRelatorio),
  },

  arquivoSolicitado: {
    content: model.tipoRelatorioDescricao || '-',
  },

  urlDownload: {
    content: {
      props: {
        value: model.devoExecutarMadrugada && !model.urlDownload,
        href: model.urlDownload,
        label: getStatusRelatorio(model),
        target: '_blank',
        anchorClass:
          model.devoExecutarMadrugada && !model.urlDownload
            ? 'tc-danger'
            : model.urlDownload
            ? 'tc-seagreen'
            : 'tc-primary',
        anchorStyle: model.urlDownload
          ? 'pointer-events: auto; cursor: pointer;'
          : 'pointer-events: none; cursor: default',
      },
      component: RenderExclamation,
    },
  },
});

export const getStatusRelatorio = (model: RelatorioGeracao) => {
  if (!model.statusRelatorio) {
    return 'Aguardando'
  }

  const status = model.statusRelatorio.idStatusRelatorioPk;

  if (status === StatusRelatorioEnum.EM_FILA && model.devoExecutarMadrugada) {
    return 'Relatório Agendado'
  }

  if (
    status === StatusRelatorioEnum.EM_FILA ||
    status === StatusRelatorioEnum.PROCESSANDO
  ) {
    return 'Aguardando'
  }

  if (status === StatusRelatorioEnum.CANCELADO) {
    return 'Cancelado'
  }

  if (model.urlDownload) {
    return 'Baixar Relatório'
  }

  return 'Aguardando'
};
